<template>
  <q-card
    flat
    :dark="isDarkModeGlobal"
  >
    <q-card-section
      class="q-gutter-xs"
    >
<!--        <q-circular-progress-->
<!--          :min="0"-->
<!--          :max="1"-->
<!--          :value="loadingValue"-->
<!--          size="20px"-->
<!--          color="primary"-->
<!--          class="q-ma-md"-->
<!--        />-->
      <q-input
        :dark="isDarkModeGlobal"
        :label="schema.electrical_power"
        filled
        dense
        type="number"
        step="1"
        v-model="electrical_power"
        :rules="rules"
        hide-bottom-space
        @update:modelValue="executeCalculation(electrical_power, 'electrical_power')"
      >
        <template #append>
          <reference-popup-proxy
            :icon="'help'"
            tooltip="Show note"
            :text="'Represents the power delivered to the ultrasound transducer to produce ultrasound waves, measured in milliwatts (mW).'"
          />
        </template>
      </q-input>
      <q-input
        :dark="isDarkModeGlobal"
        :label="schema.transducer_efficiency"
        filled
        dense
        type="number"
        step="0.000001"
        v-model="transducer_efficiency"
        :rules="rules"
        hide-bottom-space
        @update:modelValue="executeCalculation(transducer_efficiency, 'transducer_efficiency')"
      >
        <template #append>
          <reference-popup-proxy
            :icon="'help'"
            tooltip="Show note"
            :text="'Represents the ratio of acoustic power output to electrical power input, expressed as a percentage. It indicates how effectively the transducer converts electrical energy into ultrasound energy.'"
          />
        </template>
      </q-input>
      <q-input
        :dark="isDarkModeGlobal"
        :label="schema.acoustic_power"
        filled
        dense
        type="number"
        step="1"
        v-model="acoustic_power"
        :rules="rules"
        hide-bottom-space
        @update:modelValue="executeCalculation(acoustic_power, 'acoustic_power')"
      >
        <template #append>
          <reference-popup-proxy
            :icon="'help'"
            tooltip="Show note"
            :text="'Represents the ultrasound energy output from the transducer, measured in milliwatts (mW). This is the effective power transmitted as sound waves. Note that in the TUS Calculator, the acoustic power is treated as independent of the pressure amplitude, which differs from real-world behavior. The calculator uses the acoustic power to specifically calculate the TIC in the skull, while the pressure amplitude is used for metrics such as the Isppa.'"
          />
        </template>
      </q-input>
      <q-input
        :dark="isDarkModeGlobal"
        outlined
        label="Average Acoustic Power [mW]"
        dense
        v-model="average_acoustic_power"
        hide-bottom-space
        readonly
      />
    </q-card-section>
  </q-card>
</template>
<script setup lang="ts">
import {storeToRefs} from "pinia"
import {useCalculatorStore} from '../stores/calculator.store'
import {computed, ref} from "vue"
import ReferencePopupProxy from "./PopupProxyLiteratureReference.vue"
import {schema} from "../stores/mappingtable";

const calculatorStore = useCalculatorStore()
const {
  focal_depth_mm,
  thickness_of_skull_mm,
  thickness_of_scalp_mm,
  coupling_thickness_mm,
  isDarkModeGlobal,
  acoustic_power,
  electrical_power,
  transducer_efficiency,
  average_acoustic_power,
  loadingValue
} = storeToRefs(calculatorStore)

const rules = [
    val => !!val || 'This field is required',
  val => val > 0 || 'Value must be > 0'
]
const minimumValueFocalDepth = computed(() => +coupling_thickness_mm.value + +thickness_of_scalp_mm.value + +thickness_of_skull_mm.value)

const blurActiveInput = () => {
  const activeElement = document.activeElement;
  if (activeElement && activeElement.tagName === 'INPUT') {
    activeElement.blur()
  }
};

let debounceTimeout = null // Timeout reference for debounce
let interval = null // Timeout reference for interval
const loading = ref(false) // Tracks spinner visibility

let totalTime = 3000
let intervalTime = 100 // Time between each count

function executeCalculation(val: number, calcType: string) {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
    clearInterval(interval)
    loadingValue.value = 0
  }

  loading.value = true;
  interval = setInterval(() => {
  loadingValue.value += 0.1;
    if (loadingValue.value > 3) {
      clearInterval(interval); // Stop the interval when count reaches 100
      loadingValue.value = 0
    }
  }, intervalTime);
      // Start debounce timer
  debounceTimeout = setTimeout(() => {
        // After debounce delay
    loading.value = false;
    if (val > 0 && focal_depth_mm.value >= minimumValueFocalDepth.value) {
      switch (calcType) {
        case 'acoustic_power':
          calculatorStore.updateByAcousticPower()
          break
        case 'transducer_efficiency':
          calculatorStore.updateByElectricalPowerOrTransducerEfficiency()
          break
        case 'electrical_power':
          calculatorStore.updateByElectricalPowerOrTransducerEfficiency()
          break
        case 'pr':
          calculatorStore.updateByPr()
          break
        case 'MI':
          calculatorStore.updateByMI()
          break
        case 'non_derated_MI':
          calculatorStore.updateByNonDeratedMI()
          break
        default:
          calculatorStore.updateByIsppa()
          break
      }
      calculatorStore.clearNotifications()

      blurActiveInput()
    } else {
      console.error("empty value or 0 not allowed")
    }
  }, totalTime);
}
</script>
